import React from 'react';
import { IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useApolloClient } from '@apollo/client';
import CreateDialog from '../CreateDialog';
import PushNotification from '../PushNotification';
import deletePromotionMutation from '../../../graphql/promotion/mutation/delete-promotion';
import deleteEventMutation from '../../../graphql/event/mutation/delete-event';
import deleteServiceMutation from '../../../graphql/services/mutation/delete-service';

const ActionMenu = ({ card, promotion, service, company, refetch }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleDeleteClick() {
    setDeleteDialogOpen(true);
    handleClose();
  }

  function handleDeleteCancel() {
    setDeleteDialogOpen(false);
  }

  const client = useApolloClient();
  const mutation = promotion ? deletePromotionMutation : service ? deleteServiceMutation : deleteEventMutation;
  
  function handleDeleteConfirm() {
    client.mutate({
      mutation,
      variables: { _id: card._id, companyId: company?._id },
    })
      .then(() => {
        console.log(`item with id: ${card._id} was deleted!`);
         if (refetch) refetch();
        setDeleteDialogOpen(false);
      })
      .catch((error) => {
        console.log(error);
        setDeleteDialogOpen(false);
      });
  }

  const itemType = promotion ? 'promotion' : service ? 'service' : 'event';

  return (
    <div>
      <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <MoreVertIcon color="primary" />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        MenuListProps={{ style: { border: '1px solid #c7c7c7', borderRadius: 5 } }}
      >
        <CreateDialog type={itemType} data={card} handleClose={handleClose} company={company} refetch={refetch} />

        <MenuItem onClick={handleDeleteClick}>
          <Typography variant="body1" color="textSecondary">
            Delete
          </Typography>
        </MenuItem>

        {promotion ? null : <PushNotification handleClick={handleClose} />}
      </Menu>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this {itemType}? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ActionMenu;